

	import { Component, Prop } from 'vue-property-decorator';
	import { PropType } from 'vue';
	import { BaseView } from '@shared/views/BaseView';
	import { Deck } from '@shared/models';

	/** A single deck in a list of decks */
	@Component({})
	export default class DeckItem extends BaseView {

		/** The model this view is displaying */
		@Prop({ type: Object as PropType<Deck> })
		public model: Deck;

		/** A value indicating if the company should be shown */
		@Prop({ default: true })
		public showCompany: boolean;

		/** A value indicating if the year should be shown */
		@Prop({ default: true })
		public showYear: boolean;

		/** The url of this decks image */
		public imageUrl: string = '';


		/** Fires when the view is mounted */
		public mounted() {
			this.imageUrl = `https://lurker.blob.core.windows.net/decks/d_deck_${this.model.id}.jpg`;
		}

	}

